export default "__VITE_ASSET__c5d498a3__"